import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthVerification from '../animation/AuthVerification';

export default function ProtectedRoute() {
    const { isLoggedIn, isAuthInitialized } = useSelector((state) => state.auth);

    if (!isAuthInitialized) {
        return <AuthVerification />;
    }

    return isLoggedIn ? <Outlet /> : <Navigate to="/" replace />;
}
